import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-verify-Suceess",
  "use": "icon-verify-Suceess-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"icon-verify-Suceess\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M73.333 40c0 18.41-14.924 33.333-33.333 33.333C21.59 73.333 6.666 58.41 6.666 40 6.666 21.59 21.59 6.667 40 6.667 58.41 6.667 73.333 21.59 73.333 40Zm-15.982-5.15a3.325 3.325 0 1 0-4.702-4.701l-17.65 17.648-7.648-7.648a3.325 3.325 0 1 0-4.702 4.702l10 10a3.325 3.325 0 0 0 4.702 0l20-20Z\" fill=\"#069A49\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol